module.exports = __webpack_public_path__ + "img/puzzle-piece-01.2ae7f5e7.svg";